import { Typography } from "@mui/material";
import { useState } from "react";
import Button from "@mui/material/Button";
import { useTranslate } from "../../../../../hooks/useTranslate";
import Select from "../../../../../components/Select";
import "./Signees.css";
import BaseDialog from "../../../../../components/BaseDialog";
import ArrowForwardIosOutlinedIcon from "@mui/icons-material/ArrowForwardIosOutlined";
import { EMERGENCY_TYPE } from "../../../ResponsibleAdults/constants";
import cn from "classnames";

const Signees = (props) => {
    const {
        primarySignee,
        secondarySignee,
        onChangeSecondarySignee,
        contacts = [],
        isManage,
    } = props;

    const { t } = useTranslate();

    const [additional, setAdditional] = useState("select");
    const [addDialogOpen, setAddDialogOpen] = useState(false);

    const additionalOptions = contacts
        .filter((contact) => ![primarySignee?.id, secondarySignee?.id].includes(contact.contactId))
        .map((contact) => ({ value: contact.contactId, label: contact.displayName }));

    const onAddSignee = () => {
        const additionalContact = contacts.find((contact) => contact.contactId === additional);
        onChangeSecondarySignee({
            id: additional,
            name: additionalContact.displayName,
            emailAddress: additionalContact.emailAddress,
        });
        setAddDialogOpen(false);
        setAdditional("select");
    };

    return (
        <>
            <Typography variant="h5" component="div" className={cn("mt-4", isManage ? "text-white" : "")}>
                {t("enrolmentAgreement.requiredSignees")}
            </Typography>
            <div className={cn("flex align-center gap-6 mt-4", secondarySignee ? "mb-8" : "")}>
                <span className="signee-item">
                    <span className="signee-item__icon" />
                    {primarySignee.name}
                </span>
                {secondarySignee && (
                    <span className="signee-item">
                        <span className="signee-item__icon" />
                        {secondarySignee.name}
                    </span>
                )}
            </div>
            {!secondarySignee && (
                <div className="additional-signee mt-4 mb-8">
                    <Select
                        name="contact"
                        value={additional}
                        onChange={setAdditional}
                        disabled={!!secondarySignee}
                        options={[{
                            value: "select",
                            label: t("enrolmentAgreement.selectContact"),
                            disabled: true,
                        }, ...additionalOptions]}
                    />
                    <Button
                        variant="contained"
                        className="button-primary additional-signee__button"
                        onClick={() => setAddDialogOpen(true)}
                        disabled={additional === "select"}
                    >
                        {t("enrolmentAgreement.addAdditionalSignee")}
                    </Button>
                </div>
            )}
            <BaseDialog
                open={addDialogOpen}
                onClose={() => setAddDialogOpen(false)}
                withCloseButton
                isWide
            >
                <Typography variant="h2" className="text-primary" component="div">
                    {t("enrolmentAgreement.addAdditionalSigneeTitle")}
                </Typography>
                <Typography variant="body1" component="div" className="mt-4">
                    {t("enrolmentAgreement.addAdditionalSigneeDescription")}
                </Typography>
                <div className="flex align-center gap-8 mt-8">
                    <Button
                        variant="outlined"
                        className="contact-information-form__button"
                        onClick={() => setAddDialogOpen(false)}
                    >
                        {t("button.cancel")}
                    </Button>
                    <Button
                        variant="contained"
                        className={cn("contact-information-form__button", isManage ? "button-accent" : "button-primary")}
                        onClick={onAddSignee}
                    >
                        {t("enrolmentAgreement.addSignee")}
                    </Button>
                </div>
            </BaseDialog>
        </>
    );
};

export default Signees;
